import { motion } from "framer-motion";
import { FAMILIES } from "@/lib/wedding";

/**
 * Families
 * -----------------------------------------------------------
 * "Welcoming Families" - two gold-bordered cards.
 */
const CARDS = [
  { label: "Swagatotsuk", sub: "Welcomed with joy by", lines: FAMILIES.swagatotsuk },
  { label: "Darshanabhilashi", sub: "Awaiting your blessings", lines: FAMILIES.darshanabhilashi },
].filter((c) => c.lines?.length > 0); // a card with no names is hidden

export default function Families() {
  return (
    <section id="families" className="relative edge py-24 text-center" style={{ background: "linear-gradient(180deg, #FAF6EE 0%, #F1E9D8 14%, #F1E9D8 86%, #FAF6EE 100%)" }}>
      <div className="overline text-rani mb-5">Mangal Aashirwad</div>
      <h2 className="font-display text-4xl sm:text-6xl text-rani">Welcoming Families</h2>
      <div
        className="mx-auto mt-6 mb-6 h-px w-40"
        style={{ background: "linear-gradient(90deg, rgba(201,169,97,0) 0%, rgba(201,169,97,0.7) 50%, rgba(201,169,97,0) 100%)" }}
      />
      <p className="mb-12 font-display italic text-xl text-ink/70 max-w-2xl mx-auto">
        A warm invitation from our families to join us in celebrating this divine union.
      </p>

      <div className={`mx-auto grid gap-6 ${CARDS.length > 1 ? "max-w-4xl md:grid-cols-2" : "max-w-md"}`}>
        {CARDS.map((c, i) => (
          <motion.div
            key={c.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="border border-gold bg-ivory rounded-2xl px-6 py-10"
          >
            <div className="font-display italic text-rani text-2xl">{c.label}</div>
            <div className="mt-1 mb-5 text-[11px] uppercase tracking-chip text-gold-deep">{c.sub}</div>
            {c.lines.map((l) => {
              // a line is either plain text or { name, role }
              const name = typeof l === "string" ? l : l.name;
              const role = typeof l === "string" ? null : l.role;
              return (
                <div key={name} className="mt-3">
                  <p className="font-display text-lg text-ink leading-snug">{name}</p>
                  {role && <p className="text-[10px] uppercase tracking-chip text-gold-deep mt-0.5">{role}</p>}
                </div>
              );
            })}
          </motion.div>
        ))}
      </div>
    </section>
  );
}
